import { render, staticRenderFns } from "./classDaily.vue?vue&type=template&id=6580a344&scoped=true"
import script from "./classDaily.vue?vue&type=script&lang=js"
export * from "./classDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6580a344",
  null
  
)

export default component.exports